import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { ExportSelectedColumns } from "../../../../services/ProductService/AllProductList/AllProductServices";

const ExportSelectedColumn = ({ onClose, onSelectedId, onSuccess }) => {
    const [selectedFields, setSelectedFields] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filetype, setFiletype] = useState("");
    const [loading, setLoading] = useState(false);
    const [showsFileTypes, setShowsFileTypes] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const fields = {
        "General": { 'Status': 'active', 'Verified': 'is_verified' },
        "Product Management": {
            'Product Added By': 'p_add_by',
            'Product Added Date': 'p_add_date',
            'Product Added Time': 'p_add_time',
            'Product Last Modified By': 'p_last_modified_by',
            'Product Last Modified Date': 'p_last_add_date',
            'Product Last Modified Time': 'p_last_add_time',
            'Product Owner': 'p_owner',
            'Product Recommended for': 'p_recommended_for',
            'Tags': 'tag',
            // 'Assigned To': 'assigned_to'
        },
        "Product Details": {
            'Product Id': 'p_id',
            'Product Name': 'name',
            'Product Category': 'category_p',
            'Product HSN Code': 'p_hsn_code',
            'Default Unit': 'default_unit',
            'Indicative Min Price': 'indicative_min_price',
            'Indicative Max Price': 'indicative_max_price',
            'Product Price': 'p_price',
            'Product Old Price': 'p_old_price',
            'Product Discount': 'p_discount',
            'Product Images': 'product_images',
            'Production Capacity': 'production_capacity',
            'Production Capacity Unit': 'production_capacity_unit',
            'Present Stock Status': 'present_stock_status',
            'Production Lead Time': 'production_lead_time',
            'Minimum Order Quantity': 'min_order_quantity',
            'Minimum Order Quantity Unit': 'min_order_quantity_unit',
            'Attached Product Certificates': 'attached_product_certificates',
        },
        "Product Life Span": {
            'Product Life': 'p_life',
            'Product LifeSpan': 'p_lifespan'
        },
        "Description About Product": {
            'Product Certifications': 'p_certification',
            'Product Description': 'p_description',
            'Product Varients': 'p_varient'
        }
    };

    const toggleField = (label, value) => {
        setSelectedFields(prev =>
            prev.includes(value) ? prev.filter(f => f !== value) : [...prev, value]
        );
        setErrorMessage("");
    };

    const selectAllFields = () => {
        const allValues = Object.values(fields).flatMap(group => Object.values(group));
        setSelectedFields(allValues);
        setErrorMessage("");
    };

    const unselectAllFields = () => {
        setSelectedFields([]);
        setErrorMessage("Please select at least one field to export.");
    };

    const selectMandatoryFields = () => {
        const mandatoryLabels = ["Product Id", "Product Name", "Product Category", "Product HSN Code", "Status", "Assigned To", "Tags"];
        const mandatoryValues = mandatoryLabels.map(label => {
            for (const group of Object.values(fields)) {
                if (group[label]) return group[label];
            }
            return null;
        }).filter(Boolean);

        setSelectedFields(mandatoryValues);
        setErrorMessage("");
    };

    const handleShowFileTypes = () => setShowsFileTypes(true);
    const handleClose = () => onClose();

    const handleExport = async () => {
        if (selectedFields.length === 0) {
            setErrorMessage("Please select at least one field to export.");
            return;
        }
        if (!filetype) {
            setErrorMessage("Please select a file type.");
            return;
        }

        setLoading(true);
        setErrorMessage("");

        const requestData = { "p_ids": onSelectedId, "select_column": selectedFields, "file_type": filetype };
        console.log(requestData);

                try {
            console.log("Request Data:", requestData);

            const response = await ExportSelectedColumns("POST", requestData, { responseType: 'blob' });

            if (!response || !response.data) {
                console.error("Invalid response:", response);
                return;
            }

            const isBlob = response.data instanceof Blob;
            if (!isBlob) {
                const text = await response.data.text();
                console.error("Expected Blob, got text:", text);
                return;
            }

            const isExcel = filetype === "Excel";
            const mimeType = isExcel
                ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                : "text/csv";
            const fileExtension = isExcel ? "xlsx" : "csv";

            const blob = new Blob([response.data], { type: mimeType });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `SelectProductDatas.${fileExtension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error exporting file:", error);
        } finally {
            setLoading(false);
            onClose()
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center" onClick={handleClose}>
            <div className="bg-white p-6 rounded-lg shadow-lg w-2/4" onClick={(e) => e.stopPropagation()}>
                <div className="border-b border-gray-400 rounded-lg mb-5">
                    <div className="flex justify-between items-start px-4">
                        <h2 className="text-lg font-semibold">Export Selected Column</h2>
                        <button onClick={handleClose} className="text-gray-500 hover:text-gray-700 text-2xl font-bold">&times;</button>
                    </div>
                </div>

                <div className="relative py-2">
                    <button
                        onClick={handleShowFileTypes}
                        className="border border-gray-300 rounded-lg px-3 py-2 w-full text-left"
                    >
                        {filetype || "Select File Type"}
                    </button>
                    {showsFileTypes && (
                        <div className="absolute w-full bg-white border mt-1 shadow-lg rounded-md z-10">
                            <div onClick={() => { setFiletype("Excel"); setShowsFileTypes(false); setErrorMessage(""); }}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-200">
                                Excel
                            </div>
                            <div onClick={() => { setFiletype("CSV"); setShowsFileTypes(false); setErrorMessage(""); }}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-200">
                                CSV
                            </div>
                        </div>
                    )}
                    {!filetype && errorMessage.includes("file type") && <p className="text-red-500 text-sm mt-1">{errorMessage}</p>}
                </div>

                <div className="flex justify-center my-5">
                    <div className="relative w-2/3">
                        <input
                            type="text"
                            placeholder="Search Fields..."
                            className="rounded-md border-none px-4 py-2 w-full bg-blue-100 outline-blue-100"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)} />
                        <FaSearch className="absolute right-3 top-3 text-gray-500" />
                    </div>
                </div>

                <div className="flex gap-2 mb-3">
                    <button onClick={selectAllFields} className="px-3 py-1 bg-gray-200 rounded">Select All</button>
                    <button onClick={selectMandatoryFields} className="px-3 py-1 bg-gray-200 rounded">Select Mandatory</button>
                    <button onClick={unselectAllFields} className="px-3 py-1 bg-gray-200 rounded">Unselect All</button>
                </div>

                <div className="border p-3 h-40 overflow-y-auto rounded-lg">
                    {Object.entries(fields).map(([section, fieldMap]) => {
                        const filteredFields = Object.entries(fieldMap).filter(([label, value]) =>
                            label.toLowerCase().includes(searchTerm.toLowerCase())
                        );

                        if (filteredFields.length === 0) return null;

                        return (
                            <div key={section}>
                                <p className="font-bold mb-2 py-2">{section}</p>
                                <div className="grid grid-cols-2 gap-2">
                                    {filteredFields.map(([label, value]) => (
                                        <label key={value} className="flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={selectedFields.includes(value)}
                                                onChange={() => toggleField(label, value)}
                                                className="mr-2 w-4 h-4"
                                            />
                                            {label}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="flex justify-end gap-2 mt-4">
                    <button onClick={handleClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
                    <button onClick={handleExport} className="px-4 py-2 bg-blue-500 text-white rounded">Export Data</button>
                </div>
            </div>
        </div>
    );
};

export default ExportSelectedColumn;
